// extracted by mini-css-extract-plugin
module.exports = {"emptyTitle":"CaughtPokemons_emptyTitle__1Vzvr","imageContainer":"CaughtPokemons_imageContainer__mqLR3","mainContainer":"CaughtPokemons_mainContainer__2pp9f"};